<template>
  <div class="__c-menu">
    <slot name="activator" />
    <q-menu
      ref="menu"
      :anchor="currentPosition.anchor"
      :self="currentPosition.self"
      :fit="fit"
      :persistent="persistent"
      :auto-close="autoClose"
      content-style="{width: '200px'}"
    >
      <slot name="content" />
    </q-menu>
  </div>
</template>

<script>
import Vue from 'vue';

export default Vue.extend({
  name: 'CMenu',
  props: {
    position: {
      type: String,
      default: 'bottom',
    },
    fit: Boolean,
    persistent: Boolean,
    autoClose: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    currentPosition() {
      let anchor;
      let self;

      switch (this.position) {
        case 'top':
          anchor = 'top left';
          self = 'bottom left';
          break;
        case 'bottom':
          anchor = 'bottom left';
          self = 'top left';
          break;

        case 'top right':
          anchor = 'top right';
          self = 'bottom right';
          break;

        case 'bottom right':
          anchor = 'bottom right';
          self = 'top right';
          break;
      }

      return { anchor: anchor, self: self };
    },
  },
  methods: {
    hide() {
      this.$refs['menu'].hide();
    },
  },
});
</script>
